import * as correspondentBillingAction from './action';
const initialState = {
    billingPaginatedDataSuccess: [],
    billingPaginatedDataFailure: [],
    downloadBillingExcel: [],
    downloadBillingExcelFailure: [],
    correspondentListDetails: [],
    correspondentListDetailsFailure: []
}
const correspondentBillingReducer = (state = initialState, action) => {
    switch (action.type) {
        case correspondentBillingAction.VIEW_BILLING_PAGES_SUCCESS:
            return state = {
                ...state,
                billingPaginatedDataSuccess: action.data
            }
        case correspondentBillingAction.VIEW_BILLING_PAGES_FAILURE:
            return state = {
                ...state,
                billingPaginatedDataFailure: action.error
            }
        case correspondentBillingAction.DOWNLOAD_BILLING_DETAILS_EXCEL_SUCCESS:
            return state = {
                ...state,
                downloadBillingExcel: action.data
            }
        case correspondentBillingAction.DOWNLOAD_BILLING_DETAILS_EXCEL_FAILURE:
            return state = {
                ...state,
                downloadBillingExcelFailure: action.data
            }
        case correspondentBillingAction.FETCH_CORRESPONDENT_LIST_BILLING_SUCCESS:
            return state = {
                ...state,
                correspondentListDetails: action.data
            }
        case correspondentBillingAction.FETCH_CORRESPONDENT_LIST_BILLING_FAILURE:
            return state = {
                ...state,
                correspondentListDetailsFailure: action.data
            }
        default: return state
    }
}

export default correspondentBillingReducer; 